module.exports = __webpack_public_path__ + "969e28231c7b8f03f695ea4412e1c38a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Eesti-Text-Light.ttf
// module id = 42
// module chunks = 0